export default Object.freeze({
  LATITUDE: 50.990853,

  LONGITUDE: 4.537432,
});
